import { WDiamondIcon } from '@weblite/icons'
import { Button, styled, Typography } from '@mui/material'
import { useCountDownToDate } from '@weblite/logic-toolkit'
import { t } from '$i18n'
import { useUserIsTeacher } from '$logic/profile/react-hook'
import { dateWithOffset } from '$logic/client-device/time-offset.service'
import { getRemainingTime, formatRemainingTime } from '$func/date'
import { useOngoingTrialExpirationDate } from '$logic/premium-features/react-hooks'
import {
  PremiumFeatureType,
  showBuyPremiumFeatureDialog,
} from '$comp/modals/buy-premium-feature-dialog'

export function PromoteToPremium() {
  const { expiresAt: demoEndDate } = useOngoingTrialExpirationDate()

  const remainingMilliSeconds = useCountDownToDate(
    demoEndDate || 0,
    dateWithOffset,
    1000,
  )

  const remainingTime = getRemainingTime(remainingMilliSeconds)

  const onClick = () => {
    analite('OPEN_BUY_PREMIUM_PLAN_FEATURE_DIALOG', {
      source: 'CHAT_LIST',
    })
    showBuyPremiumFeatureDialog({
      featureType: PremiumFeatureType.ALL,
    })
  }

  const isTeacher = useUserIsTeacher()
  if (!isTeacher) return null

  return !demoEndDate || remainingMilliSeconds <= 1000 ? (
    <EnablePremiumButton
      fullWidth
      onClick={onClick}
      variant="contained"
      sx={{
        margin: '12px 8px',
        width: 'calc(100% - 16px)',
      }}
    >
      <WDiamondIcon sx={{ color: 'yellow500' }} />
      <Typography color="neutral000" variant="subtitle1">
        {t('chatList.promoteToPremium')}
      </Typography>
    </EnablePremiumButton>
  ) : (
    <DemoRoot
      sx={{
        margin: '12px 8px',
      }}
    >
      <Typography
        variant={remainingTime.days > 0 ? 'subtitle2' : 'subtitle3'}
        color="secondary700"
        textAlign="center"
      >
        {t('chatList.timeToEndPremiumDemo')(formatRemainingTime(remainingTime))}
      </Typography>
      <EnablePremiumButton
        onClick={onClick}
        variant="contained"
        className="small"
      >
        <WDiamondIcon
          sx={{ color: 'yellow500', width: '20px', height: '20px' }}
        />
        <Typography color="neutral000" variant="caption1">
          {t('chatList.promoteToPremium')}
        </Typography>
      </EnablePremiumButton>
    </DemoRoot>
  )
}

const EnablePremiumButton = styled(Button)`
  background: linear-gradient(267.61deg, #7841e7 0%, #38a9e1 99.81%);
  display: flex;
  align-items: center;
  gap: 8px;
  margin-right: auto;
  box-shadow: 0px 1px 4px 0px #00000040;
  box-sizing: border-box;

  &.small {
    gap: 4px;
    box-shadow: none;
    width: 100%;
    max-width: 150px;
    margin: 0;
    padding: 8px 8px 8px 12px;
    width: 139px;
    flex-shrink: 0;
    height: 36px;
  }
`

const DemoRoot = styled('div')`
  background: linear-gradient(90deg, #c8e8f8 0%, #ebe8fd 100%);
  display: flex;
  align-items: center;
  gap: 4px;
  justify-content: space-between;
  border-radius: 12px;
  padding: 8px 12px 8px;
  box-sizing: border-box;
`
